import React from "react";
import {
  Box,
  Typography,
  Paper,
  FormControlLabel,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../Constants/theme";
import colors from "../../../Constants/colors";
import { useTranslation } from "react-i18next";
import { AnnexBody } from "./AnnexBody";
import { AnnexDocument } from "../../../Core/useAnnexActions";
import { ComoSwitch } from "../../Common/ComoSwitch";
interface Props {
  companyId: number;
  showPlaceholders: boolean;
  setShowPlaceholders: React.Dispatch<React.SetStateAction<boolean>>;
  annex: AnnexDocument[];
  setAnnex: React.Dispatch<React.SetStateAction<AnnexDocument[]>>;
  predefinedAnnex: Record<number, AnnexDocument[]>;
  setPredefinedAnnex: React.Dispatch<
    React.SetStateAction<Record<number, AnnexDocument[]>>
  >;
  selectedPredefinedSection: number | null;
  setSelectedPredefinedSection: React.Dispatch<
    React.SetStateAction<number | null>
  >;
  handleNextStep: () => void;
  isStepAccessible: (stepIndex: number) => boolean;
  currentStep: number;
}

export default function ManageAnnexStep({
  companyId,
  showPlaceholders,
  setShowPlaceholders,
  annex,
  setAnnex,
  predefinedAnnex,
  setPredefinedAnnex,
  selectedPredefinedSection,
  setSelectedPredefinedSection,
  handleNextStep,
  isStepAccessible,
  currentStep,
}: Props) {
  const { t } = useTranslation("evaluationPage");
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleToggle = () => {
    setShowPlaceholders(!showPlaceholders);
  };

  return (
    <Box sx={{ width: "100%", pt: 2, pb: 2 }}>
      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          mb: 2,
          borderRadius: 2,
          border: `1px solid ${colors.gray200}`,
          borderLeft: `4px solid ${colors.primary_dark}`,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Typography
            variant={mobile ? "h5" : "h4"}
            sx={{
              fontWeight: 600,
              color: colors.primary_dark,
              marginBottom: 0,
              textAlign: "center",
            }}
          >
            {t("evaluationPage.annexOrder")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <FormControlLabel
              control={
                <ComoSwitch
                  checked={showPlaceholders}
                  onChange={handleToggle}
                />
              }
              label={
                <Typography variant="body2" sx={{ color: colors.gray700 }}>
                  {t("evaluationPage.predefinedStructure")}
                </Typography>
              }
              sx={{ marginRight: 0 }}
            />
          </Box>
        </Box>
      </Paper>

      <AnnexBody
        companyId={companyId}
        showPlaceholders={showPlaceholders}
        annex={annex}
        setAnnex={setAnnex}
        predefinedAnnex={predefinedAnnex}
        setPredefinedAnnex={setPredefinedAnnex}
        selectedPredefinedSection={selectedPredefinedSection}
        setSelectedPredefinedSection={setSelectedPredefinedSection}
        handleNextStep={handleNextStep}
        isStepAccessible={isStepAccessible}
        currentStep={currentStep}
      />
    </Box>
  );
}
